var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nuxt-child'),_vm._v(" "),_c('the-entry',{attrs:{"data":_vm.entry,"gray":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }